export default "__VITE_ASSET__fde7643e__"